export default __webpack_public_path__ + "static/media/light.800421a1.svg";